module.exports = __webpack_public_path__ + "static/media/ios-basketball.30ac26ed.svg";